import { React, useState } from "react";
import { useNavigate } from "react-router-dom";

//package import

import {
  Typography,
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { RoutesUrls, pouRoutes } from "../../../../Services/Routes/APP";

//constants

const headings = ["Name", "", "", "", "Date", "Units Requested", "Actions"];

const rows = [
  {
    most_recent: "Sydney",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Queens Land",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Victoria",
    date: "27-12-2021",
    units_requested: "10 K",
  },
  {
    most_recent: "Tasmania",
    date: "19-12-2021",
    units_requested: "10 K",
  },
];

//component

const Seemore = () => {
  const navigate = useNavigate();

  const addHandler = () => {
    navigate(RoutesUrls.pouAdmin + pouRoutes.dashboardDetails);
  };
  //hooks
  const [searchData, setSearchData] = useState("");

  const theme = useTheme();

  // render

  return (
    <Box padding={2}>
      <Typography
        variant="h5"
        fontWeight={"bold"}
        component={"span"}
        sx={{
          paddingBottom: 2,

          textTransform: "uppercase",
        }}
      >
        Requests Recieved
      </Typography>
      <Typography color={"text.grayText"}>Most Recent</Typography>

      <Box marginTop={2} display={"flex"} justifyContent={"flex-end"}>
        <TextField
          size="small"
          placeholder="Search"
          InputProps={{
            endAdornment: (
              <SearchIcon
                sx={{
                  color: theme.palette.primary.dark,
                }}
              />
            ),
          }}
          sx={{
            borderRadius: 25,
            backgroundColor: theme.palette.secondary.dark,
            ".MuiOutlinedInput-root": {
              borderRadius: 25,
              paddingX: 2,
            },
          }}
        ></TextField>
      </Box>
      <Box>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headings?.map((h, index) => (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                    }}
                    align="center"
                    key={`${index}-table-heading-${h}`}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 ? (
                rows?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 2}`}>
                    <TableCell align="center">{row?.most_recent}</TableCell>
                    <TableCell align="center"> </TableCell>
                    <TableCell align="center"> </TableCell>
                    <TableCell align="center"> </TableCell>

                    <TableCell align="center">{row?.date}</TableCell>
                    <TableCell align="center">{row?.units_requested}</TableCell>

                    <TableCell align="center">
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={addHandler}
                        sx={{
                          borderRadius: 4,
                        }}
                      >
                        Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  {" "}
                  <TableCell colSpan={7}>
                    {" "}
                    <Typography
                      width={"100%"}
                      variant="body1"
                      sx={{
                        textAlign: "center",
                      }}
                    >
                      {" "}
                      No Data Found
                    </Typography>{" "}
                  </TableCell>{" "}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default Seemore;
